import React from 'react';
import {sx} from './sx'
import PrimaryButtonSingleVoyage
    from "@containers/singleVoyage/ui/buttonts/primaryButtonSingleVoyage/PrimaryButtonSingleVoyage";
import {useTranslation} from 'react-i18next';
import ActionUiHandler from "@ui/template/actionUiHandler/ActionUiHandler";
import moment from 'moment';
import {DATE_FORMAT_POINT_SINGLE_VOYAGE} from "@containers/singleVoyage/containers/points/constants/dateFormat";
import MuiDatePicker from "@ui/datePicker/muiDatePicker/MuiDatePicker";
import {getErrorProps} from "@helpers/error";
import {IRouteInfoMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/types";
import DividerCustom from "@ui/dividerCustom/DividerCustom";
import CheckboxCustom from "@ui/checkboxCustom/CheckboxCustom";
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import InputCustom from '@ui/inputs/InputCustom';
import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";
import SelectStatusSingleVoyageRuns
    from "@containers/singleVoyage/select/selectStatusVoyage/SelectStatusSingleVoyageRuns";
import SelectPlannedResourcesSingleVoyage
    from "@containers/singleVoyage/containers/plannedResources/select/selectResources/SelectPlannedResourcesSingleVoyage";
import {StateMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/route/mutateRoute/types";
import {ErrorMessage} from "@hooks/validate/types";
import {
    DATE_FORMAT_ROUTE_INFO_MUTATE_SINGLE_VOYAGE
} from "@containers/singleVoyage/mutateVoyage/route/constants/dateFormat";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    onSave?: (point: IRouteInfoMutateSingleVoyage) => void,
    closeModalFn?: () => void,
    stateMutateSingleVoyage: StateMutateSingleVoyage,
    error?: boolean,
    errorMessage?: ErrorMessage,
    labelBtn?: string,
    sx?: SxType
    accountId: string | number
}

const BaseMutateRouteMutateSingleVoyage = ({
                                               onSave,
                                               closeModalFn,
                                               stateMutateSingleVoyage,
                                               error,
                                               errorMessage,
                                               labelBtn,
                                               sx: sxProps = {},
                                               accountId
                                           }: IProps) => {

    const {t} = useTranslation()

    const onSaveFn = () => {
        onSave({
            title: stateMutateSingleVoyage.title,
            plannedStart: moment(stateMutateSingleVoyage.plannedStart, DATE_FORMAT_ROUTE_INFO_MUTATE_SINGLE_VOYAGE).toISOString(),
            plannedEnd: moment(stateMutateSingleVoyage.plannedEnd, DATE_FORMAT_ROUTE_INFO_MUTATE_SINGLE_VOYAGE).toISOString(),
            driverId: stateMutateSingleVoyage.driverId ? Number(stateMutateSingleVoyage.driverId) : null,
            deviceId: Number(stateMutateSingleVoyage.deviceId),
            config: {
                onRouteControl: stateMutateSingleVoyage.onRouteControl,
                waypointOrderControl: stateMutateSingleVoyage.waypointOrderControl,
                notification: stateMutateSingleVoyage.notification
            },
            status: stateMutateSingleVoyage.status
        })
        closeModalFn && closeModalFn()
    }

    const handleChangeStatus = (status: VoyageStatusSingleVoyage) => {
        stateMutateSingleVoyage.onChangeStatus(status)
        if (status === 'PLANNED_FOR_AUTORUN') {
            stateMutateSingleVoyage.onChangeDriverId('')
            stateMutateSingleVoyage.onChangeDeviceId('')
        }
    }

    const handleChangePlannedStart = (plannedStart: string) => {
        stateMutateSingleVoyage.onChangePlannedStart(plannedStart)
        if (stateMutateSingleVoyage.status === 'PLANNED_FOR_AUTORUN') {
            stateMutateSingleVoyage.onChangeDriverId('')
            stateMutateSingleVoyage.onChangeDeviceId('')
        }
    }

    const handleChangePlannedEnd = (plannedEnd: string) => {
        stateMutateSingleVoyage.onChangePlannedEnd(plannedEnd)
        if (stateMutateSingleVoyage.status === 'PLANNED_FOR_AUTORUN') {
            stateMutateSingleVoyage.onChangeDriverId('')
            stateMutateSingleVoyage.onChangeDeviceId('')
        }
    }
    const isPlannedForAutorun = stateMutateSingleVoyage.status === 'PLANNED_FOR_AUTORUN'
    const isNotPlanned = stateMutateSingleVoyage.status !== 'READY_FOR_MANUAL_RUN' && stateMutateSingleVoyage.status !== 'PLANNED_FOR_AUTORUN'

    return (
        <ActionUiHandler
            sx={sxProps ? {
                ...sx.root,
                ...sxProps
            } : sx.root}
        >
            <InputCustom
                value={stateMutateSingleVoyage.title}
                onChange={stateMutateSingleVoyage.onChangeTitle}
                label={t('base.name')}
                {...getErrorProps({errorMessage, error, key: 'title'})}
            />

            {!isNotPlanned && <>
                <SelectStatusSingleVoyageRuns
                    {...getErrorProps({errorMessage, error, key: 'status'})}
                    value={stateMutateSingleVoyage.status}
                    onChange={handleChangeStatus}
                    label={t('base.activationType')}
                />

                <DividerCustom
                    icon={<QueryBuilderIcon/>}
                    sx={sx.divider}
                    label={t('singleVoyage.scheduledTime')}
                />

                <MuiDatePicker
                    value={stateMutateSingleVoyage.plannedStart}
                    onChange={handleChangePlannedStart}
                    format={DATE_FORMAT_POINT_SINGLE_VOYAGE}
                    showHoursAndMinutes
                    fullWidth
                    sx={{padding: '0'}}
                    label={t(!isPlannedForAutorun ? 'singleVoyage.plannedDateTimeRouteStart' : 'singleVoyage.dateTimeRouteStart')}
                />

                <MuiDatePicker
                    value={stateMutateSingleVoyage.plannedEnd}
                    onChange={handleChangePlannedEnd}
                    format={DATE_FORMAT_POINT_SINGLE_VOYAGE}
                    showHoursAndMinutes
                    fullWidth
                    sx={{padding: '0'}}
                    label={t(!isPlannedForAutorun ? 'singleVoyage.plannedDateTimeRouteEnd' : 'singleVoyage.dateTimeRouteEnd')}
                />
            </>}


            <SelectPlannedResourcesSingleVoyage
                accountId={accountId}
                errorMessage={errorMessage}
                error={error}
                deviceId={stateMutateSingleVoyage.deviceId || ''}
                onChangeDeviceId={stateMutateSingleVoyage.onChangeDeviceId}
                driverId={stateMutateSingleVoyage.driverId || ''}
                onChangeDriverId={stateMutateSingleVoyage.onChangeDriverId}
                plannedStart={isPlannedForAutorun ? moment(stateMutateSingleVoyage.plannedStart, DATE_FORMAT_POINT_SINGLE_VOYAGE).toISOString() : undefined}
                plannedEnd={isPlannedForAutorun ? moment(stateMutateSingleVoyage.plannedEnd, DATE_FORMAT_POINT_SINGLE_VOYAGE).toISOString() : undefined}
            />

            <DividerCustom sx={sx.divider}/>

            <CheckboxCustom
                checked={stateMutateSingleVoyage.onRouteControl}
                onChange={stateMutateSingleVoyage.onChangeOnRouteControl}
                label={t('singleVoyage.optimalRouteControl')}
            />

            <CheckboxCustom
                checked={stateMutateSingleVoyage.waypointOrderControl}
                onChange={stateMutateSingleVoyage.onChangeWaypointOrderControl}
                label={t('singleVoyage.strictStopOrder')}
            />
            {!isNotPlanned && <CheckboxCustom
                checked={stateMutateSingleVoyage.notification}
                onChange={stateMutateSingleVoyage.onChangeNotification}
                label={t('singleVoyage.notifyDriverAboutTrip')}
            />
            }
            {onSave && <PrimaryButtonSingleVoyage
                sx={sx.btn}
                onClick={onSaveFn}
            >
                {labelBtn || t('base.save')}
            </PrimaryButtonSingleVoyage>}

        </ActionUiHandler>
    );
};

export default BaseMutateRouteMutateSingleVoyage;
